(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-pix/assets/route-play-pix.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-pix/assets/route-play-pix.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  ForEach
} = svs.components.lbUtils.reactConditionals;
const {
  PixItem
} = svs.components.tipsen.pixItem;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG,
  BREAKPOINT_MD,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  Carousel,
  CarouselItem
} = svs.components.lbUi.carousel;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  selectQuickPlayPixSizes,
  selectDefaultPixSize,
  selectMinStake
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  selectActiveWallet,
  useWallets
} = svs.components.tipsen.walletSelectors;
const {
  WALLET_SELFSERVICE
} = svs.components.tipsen.wallet.walletType;
const {
  WALLET_ID_PLAYER
} = svs.components.tipsen.wallet.walletId;
const {
  WalletComponent,
  WalletAddition
} = svs.components.tipsen.walletComponent;
const {
  selectCompetitionDraws,
  selectCompetition
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  getProductCompetitionId
} = svs.components.lbUtils.brandMapping.fn;
const {
  getSystemSizeForSupportedCompetition
} = svs.components.tipsen.engine.utils.competitionHelpers;
const {
  CompetitionType
} = svs.components.marketplaceCompetition.constants;
const {
  useSetUpMarketplaceBalanceListener
} = svs.components.tipsen.couponId;
const {
  useActionListener
} = svs.components.tipsen.hooks;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const RoutePlayPix = () => {
  useSetUpMarketplaceBalanceListener();
  const minStake = useSelector(state => selectMinStake(state));
  const quickPlayPixSizes = useSelector(state => selectQuickPlayPixSizes(state));
  const defaultPixSize = useSelector(state => selectDefaultPixSize(state));
  const indexOfDefaultPixSize = quickPlayPixSizes.indexOf(defaultPixSize);
  const draw = useCurrentDraw();
  const {
    drawNumber,
    productId,
    sportType
  } = draw || {};
  useActionListener();
  const isValidPixSportType = sportType !== SportTypes.Handball;
  const additionsGridClassNames = ['tipsen-additions-grid'];
  const isLarge = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  const isMedium = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isAlmostMedium = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const carouselOptions = {};
  if (isMedium) {
    carouselOptions.itemsPerPage = 3;
  }
  if (isAlmostMedium) {
    carouselOptions.isMobile = true;
    carouselOptions.itemsPerPage = 1;
    if (indexOfDefaultPixSize > -1) {
      carouselOptions.selectedIndex = indexOfDefaultPixSize;
    }
  } else {
    additionsGridClassNames.push('additions-grid-pix');
  }
  const wallet = useSelector(selectActiveWallet);
  const isSelfserviceWallet = wallet && WALLET_SELFSERVICE === wallet.type;
  const wallets = useWallets();
  const hasOnlyPlayerWallet = wallets.length === 1 && wallets[0].id === WALLET_ID_PLAYER;
  const showWallet = !isSelfserviceWallet && wallets.length > 0 && !hasOnlyPlayerWallet;

  const competitionId = getProductCompetitionId(productId);
  const currentCompetition = useSelector(state => selectCompetition(state, competitionId));
  const drawsInCompetition = useSelector(state => selectCompetitionDraws(state, competitionId));
  const isCurrentDrawInCompetition = drawsInCompetition === null || drawsInCompetition === void 0 ? void 0 : drawsInCompetition.includes(drawNumber);
  const currentEngineDefintion = useSelector(selectEngineDefinition);
  let competitionSystemSize;
  let competitionType;
  let competitionBranding;
  if (currentCompetition && isCurrentDrawInCompetition) {
    competitionType = currentCompetition.compType;
    competitionBranding = currentCompetition.compType === CompetitionType.TipsEM ? 'tips-em' : 'tips-sm';
    competitionSystemSize = getSystemSizeForSupportedCompetition(currentEngineDefintion, currentCompetition);
  }
  const PixItemElement = _ref => {
    let {
      index,
      pixSize
    } = _ref;
    return React.createElement(PixItem, {
      competitionBranding: pixSize === competitionSystemSize ? competitionBranding : undefined,
      competitionType: competitionType,
      draw: draw,
      drawNumber: drawNumber,
      index: index,
      isCompetition: pixSize === competitionSystemSize,
      key: index,
      productId: productId,
      rowPrice: minStake,
      systemCost: parseInt(pixSize, 10),
      wallet: wallet
    });
  };
  const GridElement = () => React.createElement("div", {
    className: "pg_route_play_pix__grid"
  }, React.createElement(ForEach, {
    array: quickPlayPixSizes,
    render: (pixSize, index) => {
      if (!pixSize) {
        return null;
      }
      const keyIndex = index + 1;
      return React.createElement(PixItemElement, {
        index: index,
        key: keyIndex,
        pixSize: pixSize
      });
    }
  }));
  return React.createElement("section", {
    className: "pg_route_play_pix"
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium"
  }, "PIX! F\xE4rdiga spel"), React.createElement("p", {
    className: "pg_route_play_pix__subtitle"
  }, "".concat(isValidPixSportType ? 'Välj summa och köp spelet.' : 'För tillfället går det inte att spela PIX! på handboll.')), showWallet && React.createElement("div", {
    className: "tipsen-additions"
  }, React.createElement("div", {
    className: additionsGridClassNames.join(' ')
  }, React.createElement(WalletComponent, {
    Component: WalletAddition
  }))), isLarge && isValidPixSportType && React.createElement(Carousel, {
    className: "pg_route_play_pix__carousel",
    options: carouselOptions
  }, quickPlayPixSizes.map((pixSize, index) => {
    if (!pixSize) {
      return null;
    }
    const keyIndex = index + 1;
    return React.createElement(CarouselItem, {
      key: keyIndex
    }, React.createElement(PixItemElement, {
      index: index,
      pixSize: pixSize
    }));
  }).filter(Boolean)), !isLarge && isValidPixSportType && React.createElement(GridElement, null));
};
setGlobal('svs.components.tipsen.RoutePlayPix', RoutePlayPix);

 })(window);